import { useBooleanState } from '@cian/react-utils';

import { useCallback } from 'react';

import { useCAForCard } from 'shared/hooks/useCAForCard';
import { CardComplaintContext } from 'shared/types/CardComplaintContext';

export function usePrepareCardComplaintContext(): CardComplaintContext {
  const complaintModalVisibilityState = useBooleanState();
  const caForCard = useCAForCard();

  const onModalClose = useCallback<VoidFunction>(() => {
    complaintModalVisibilityState.setFalse();
  }, [complaintModalVisibilityState]);

  const onModalOpen = useCallback<VoidFunction>(() => {
    caForCard({ action: 'click', category: 'complain' }, { label: true });
    complaintModalVisibilityState.setTrue();
  }, [complaintModalVisibilityState, caForCard]);

  return {
    isModalOpen: complaintModalVisibilityState.state,
    onModalClose,
    onModalOpen,
  };
}
